import type { ReferralStatus } from './types';

const TRANSITIONS: Record<ReferralStatus, readonly ReferralStatus[]> = {
  submitted: ['assigned', 'declined'],
  assigned: ['recon_attached', 'complete', 'declined'],
  recon_attached: ['complete', 'declined'],
  complete: [],
  declined: [],
};

export const TERMINAL_STATUSES = ['complete', 'declined'] as const;

export const STATUS_LABELS: Record<ReferralStatus, string> = {
  submitted: 'Submitted',
  assigned: 'Assigned',
  recon_attached: 'Recon Attached',
  complete: 'Complete',
  declined: 'Declined',
};

/** What a plumber sees. Internal routing detail is deliberately hidden. */
export const PLUMBER_STATUS_LABELS: Record<ReferralStatus, string> = {
  submitted: 'Submitted',
  assigned: 'In Progress',
  recon_attached: 'In Progress',
  complete: 'Complete',
  declined: 'Not Accepted',
};

export function canTransition(from: ReferralStatus, to: ReferralStatus): boolean {
  if (from === to) return false;
  return TRANSITIONS[from].includes(to);
}

/**
 * The status StatusChip should colour by when rendering for a plumber.
 * PLUMBER_STATUS_LABELS deliberately collapses 'assigned' and
 * 'recon_attached' to the same "In Progress" label so a plumber cannot infer
 * that a recon team was attached; colouring the chip from the raw status
 * would undo that the moment recon is attached (amber turning violet). This
 * maps every status to the one whose colour the plumber should see, so any
 * two statuses that share a plumber-facing label always render identically.
 */
export function plumberColorStatus(status: ReferralStatus): ReferralStatus {
  return status === 'recon_attached' ? 'assigned' : status;
}
